// @flow
import { UsersActionTypes } from './constants';

type UsersAction = { type: string, payload: {} | string };

// common success
export const usersApiResponseSuccess = (actionType: string, data: any): UsersAction => ({
    type: UsersActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const usersApiResponseError = (actionType: string, error: string): UsersAction => ({
    type: UsersActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listUsuarios = (params: any): UsersAction => ({
    type: UsersActionTypes.LIST_USERS,
    payload: params,
});
export const getUsuario = (id: string): UsersAction => ({
    type: UsersActionTypes.GET_USER,
    payload: { id },
});

export const addUsuario = (usuario:any):UsersAction=>({
    type:UsersActionTypes.ADD_USER,
    payload:usuario
})
export const updateUsuario = (usuario:any):UsersAction=>({
    type:UsersActionTypes.UPDATE_USER,
    payload:usuario
})

export const updateUsuarioSelf = (usuario:any):UsersAction=>({
    type:UsersActionTypes.UPDATE_USER_SELF,
    payload:usuario
})

export const deleteUsuario = (id:string):UsersAction=>({
    type:UsersActionTypes.DELETE_USER,
    payload:{id}
})

export const resetUsuario = (): UsersAction => ({
    type: UsersActionTypes.RESET,
    payload: {},
});

